import React from "react";
import { RootAnswers } from "../../components";
import { AnswerInterface, ApiHelper, PendingCommand, OverlayInterface, QuestionInterface, ArrayHelper } from "../../helpers";

interface Props {
  overlay: OverlayInterface,
  saveCallback: (answers: AnswerInterface[]) => void,
  pendingCommand: PendingCommand,
  sendCommand?: (cmd: PendingCommand) => void
}

export const OverlayAnswers: React.FC<Props> = props => {
  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null);
  const [answers, setAnswers] = React.useState<AnswerInterface[]>([]);

  const init = () => {
    if (props.overlay?.templateId) loadQuestions(props.overlay.templateId);
  }


  const loadQuestions = async (templateId: number) => {
    await ApiHelper.getAnonymous<QuestionInterface[]>("/questions/template/" + templateId.toString())
      .then(data => setQuestions(data || []))
      .catch(err => console.error("Failed to load overlay questions:", err));
    if (props.overlay.id > 0) {
      if (props.overlay.answers) setAnswers(props.overlay.answers);
      else ApiHelper.getAnonymous<AnswerInterface[]>("/answers/overlay/" + props.overlay.id.toString())
        .then(data => setAnswers(data || []))
        .catch(err => console.error("Failed to load overlay answers:", err));
    }
  }


  const handleSave = async (overlayId: number) => {
    //answers.forEach(a => a.overlayId = overlayId);
    //await AnswerHelper.preSave(answers, questions, (percent) => {
    //props.sendCommand({ action: "updateProgress", parameter: percent })
    //});
    //const promises: Promise<any>[] = []
    //if (answers.length > 0) promises.push(ApiHelper.post("/answers", answers));
    //Promise.all(promises).then(() => { props.saveCallback(answers) });
    props.saveCallback(answers);
  }

  const handleUpdateAnswer = (answerCopy: AnswerInterface) => {
    const result = [...answers];
    const answer: AnswerInterface = ArrayHelper.getOne(result, "questionId", answerCopy.questionId);
    answer.value = answerCopy.value;
    setAnswers(result);
  }

  const handleParentCommand = () => {
    if (props.pendingCommand) {
      switch (props.pendingCommand.action) {
        case "save":
          handleSave(parseInt(props.pendingCommand.parameter as string, 0));
          break;
        case "updateAnswer":
          handleUpdateAnswer(props.pendingCommand.parameter as AnswerInterface);
          break;
      }
    }
  }

  const updatePreview = () => {
    if (questions && answers) props.sendCommand({ action: "updatePreview", parameter: { questions, answers } });
  }

  React.useEffect(handleParentCommand, [props.pendingCommand]); // eslint-disable-line
  React.useEffect(init, [props.overlay.id, props.overlay.templateId, props.overlay.answers]); // eslint-disable-line
  React.useEffect(updatePreview, [answers, questions]); // eslint-disable-line

  return (
    <RootAnswers questions={questions} answers={answers} sendCommand={props.sendCommand} />
  );
};